import { render, staticRenderFns } from "./TeacherIndex.vue?vue&type=template&id=d770e658&scoped=true&"
import script from "./TeacherIndex.vue?vue&type=script&lang=js&"
export * from "./TeacherIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d770e658",
  null
  
)

export default component.exports